export default __webpack_public_path__ + "static/media/diamond-clarity-3@3x.29473a64.png";